import axios from "axios";
import { SMU_TOKEN, SMU_USER } from "../../constants";
import { toast } from "../../helpers/smu-alerts/smu-lerts";
import { logoutUser  } from "../users";
const baseURL =
  "/";
const _this = axios.create({ baseURL });

_this.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem(SMU_TOKEN);
    if (token) config.headers.Authorization = "Bearer " + token;
    return config;
  },
  (err) => console.error(err)
);

_this.interceptors.response.use(
  (response) => response,
  (error) => {
    if (
      error.response?.status === 401 ||
      error.response?.data?.error?.name === "ExpiredJwtToken"
    ) {

      const _logoutUser = new FormData();
      const _username = JSON.parse(localStorage.getItem(SMU_USER)).username
      
      _logoutUser.append("username", _username);

      logoutUser(_logoutUser)
      .then(({ error }) => {
        if (!!error) throw new Error(error.message);

        localStorage.removeItem(SMU_TOKEN);
        localStorage.removeItem(SMU_USER);
        
      })
      .catch((err) => {
        console.error(err);//toast({ icon: "error", title: err });
      })
      .finally(() => {
        toast({ icon: "error", title: "La sesión ha expirado!" }).then(() => {
          return (window.location.href = "/");
        });
      });
      
    }
    return Promise.reject(error);
  }
);

export default _this;
